<div class="payer-plans-wrapper" [@fadeIn]>

  <!-- Header -->
  <div class="section-header">
    <div class="section-header-left">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256" fill="currentColor" class="section-icon">
        <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM32,96H224v24H32Z" opacity="0.3"/>
        <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224ZM32,96H224v24H32Z"/>
        <rect x="48" y="144" width="40" height="16" rx="8"/>
      </svg>
      <div>
        <h2 class="title-secondary">Meus Planos como Pagador</h2>
        <p class="title-secondary-description">Planos nos quais você é responsável pelo pagamento</p>
      </div>
    </div>
    <button mat-icon-button (click)="loadPlans()" [disabled]="isLoading()" matTooltip="Atualizar">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <mat-progress-bar *ngIf="isLoading()" mode="indeterminate" color="primary"></mat-progress-bar>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoading() && plans().length === 0">
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 256 256" fill="currentColor" class="empty-icon">
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H216V96H40ZM40,200V112H216v88Z" opacity="0.3"/>
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V112H216Zm0-104H40V56H216Z"/>
    </svg>
    <p class="empty-title">Nenhum plano encontrado</p>
    <p class="empty-desc">Você não é pagador de nenhum plano no momento.</p>
  </div>

  <!-- Plans Grid -->
  <div class="plans-grid" [@listStagger]="plans().length" *ngIf="!isLoading() && plans().length > 0">
    <div class="card payer-plan-card" *ngFor="let plan of plans()" [@fadeIn]>

      <!-- Status Badge -->
      <div class="card-header payer-plan-header">
        <div class="payer-plan-title-row">
          <!-- Status Visual -->
          <ng-container [ngSwitch]="getPayerStatus(plan)">
            <span *ngSwitchCase="'awaiting-acceptance'" class="badge badge-warning">
              <mat-icon class="badge-icon">hourglass_top</mat-icon> Aguardando aceitação
            </span>
            <span *ngSwitchCase="'accepted'" class="badge badge-success">
              <mat-icon class="badge-icon">check_circle</mat-icon> Aceito
            </span>
            <span *ngSwitchCase="'awaiting-confirmation'" class="badge badge-warning">
              <mat-icon class="badge-icon">schedule</mat-icon> Aguardando confirmação
            </span>
            <span *ngSwitchCase="'payment-active'" class="badge badge-success">
              <mat-icon class="badge-icon">check_circle</mat-icon> Pagamento ativo
            </span>
            <span *ngSwitchDefault class="badge badge-primary">
              <mat-icon class="badge-icon">info</mat-icon> Pagador
            </span>
          </ng-container>
          <span class="plan-id-tag">#{{ plan.id }}</span>
        </div>
        <h3 class="card-title">{{ plan.name || 'Plano sem nome' }}</h3>
      </div>

      <!-- Info -->
      <div class="card-body payer-plan-body">
        <div class="info-row">
          <span class="info-label">Titular</span>
          <span class="info-separator"></span>
          <span class="info-data">{{ formatCnpj(plan.cpfcnpj) }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Valor Total</span>
          <span class="info-separator"></span>
          <span class="info-data value-highlight">{{ formatCurrency(plan.finalTotal) }}</span>
        </div>
        <div class="info-row" *ngIf="plan.packageType">
          <span class="info-label">Pacote</span>
          <span class="info-separator"></span>
          <span class="info-data">{{ plan.packageType }}</span>
        </div>
      </div>

      <!-- Ação: Confirmar Pagamento -->
      <div class="card-footer" *ngIf="canConfirmPayment(plan)">
        <div class="alert alert-warning confirm-alert">
          <mat-icon>notifications_active</mat-icon>
          <span>O titular solicitou a cobrança. Confirme o pagamento.</span>
        </div>
        <button mat-flat-button color="primary" class="btn-confirm" (click)="openConfirmModal(plan)">
          <mat-icon>payment</mat-icon>
          Confirmar Pagamento
        </button>
      </div>

    </div>
  </div>

</div>
